jQuery(document).ready(function () {
    // Все обработчики делегированные: компоненты работают и в статических формах,
    // и в динамически подгруженных (например, форма проекта в модалке через form-modal).

    // Выбор файлов (клик по зоне, drag-and-drop или вставка из буфера — всё это складывается
    // во вход .image-upload-input) — загрузка на сервер с прогрессом по компоненту.
    jQuery(document).on('change', '.image-upload-input', function () {
        let files = Array.from(this.files);
        if (files.length === 0) return;

        this.value = '';

        let el = jQuery(this).closest('.image-upload-component');
        let field = el.data('field');
        let width = el.data('width');
        let height = el.data('height');

        // Лимит количества изображений (data-max): не даём выбрать больше, чем осталось мест.
        let max = parseInt(el.data('max'), 10);
        if (!isNaN(max) && el.find('.image-upload-item').length + files.length > max) {
            if (window.showToast) window.showToast('Можно добавить не более ' + max + ' изображений', 'danger');
            return;
        }

        let progress = el.find('.image-upload-progress');
        let progressBar = progress.find('.progress-bar');

        progress.removeClass('d-none');
        progressBar.css('width', '0%');

        let total = files.length;
        let uploaded = 0;

        files.forEach(function (file) {
            let formData = new FormData();
            formData.append('file', file);
            formData.append('field', field);
            formData.append('width', width);
            formData.append('height', height);
            formData.append('multiple', el.data('multiple') ? 1 : 0);

            jQuery.ajax({
                url: el.data('upload-url'),
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                xhr: function () {
                    let xhr = new XMLHttpRequest();
                    xhr.upload.addEventListener('progress', function (e) {
                        if (e.lengthComputable) {
                            let percent = Math.round(((uploaded + e.loaded / e.total) / total) * 100);
                            progressBar.css('width', percent + '%');
                        }
                    });
                    return xhr;
                },
                success: function (data) {
                    if (!data.success) return;

                    let list = el.find('.image-upload-list');

                    // Режим одной картинки: новая заменяет старую — старые элементы удаляем.
                    // Файлы со диска сервер удалит при сохранении (removedFilePaths).
                    if (!el.data('multiple')) {
                        list.find('.image-upload-item').remove();
                    }

                    list.append(data.html);
                },
                complete: function () {
                    uploaded++;
                    if (uploaded === total) {
                        progress.addClass('d-none');
                        progressBar.css('width', '0%');
                    }
                },
            });
        });
    });

    // Удаление изображения из списка.
    jQuery(document).on('click', '.image-upload-remove', function () {
        jQuery(this).closest('.image-upload-item').remove();
    });

    // Обрезка: общее всплывающее окно кроппера (openCropperWindow) — всегда открывается поверх остальных окон.
    jQuery(document).on('click', '.image-upload-crop', function () {
        let component = jQuery(this).closest('.image-upload-component');
        let item = jQuery(this).closest('.image-upload-item');

        window.openCropperWindow('/storage/' + item.data('original'), {
            title: 'Настройка изображения',
            cropperOptions: {
                aspectRatio: (Number(component.attr('data-width')) || 1200) / (Number(component.attr('data-height')) || 630),
                viewMode: 1,
                dragMode: 'crop',
                autoCropArea: 0.8,
                restore: false,
                guides: false,
                center: false,
                highlight: false,
                cropBoxMovable: true,
                cropBoxResizable: true,
                toggleDragModeOnDblclick: false,
                rotatable: false,
                scalable: false,
            },
            onSave: function (cropper, config, hideLoadBox) {
                let data = cropper.getData(true);

                if (!data.width || !data.height) {
                    hideLoadBox();
                    if (window.showToast) window.showToast('Не удалось определить область обрезки', 'danger');
                    return;
                }

                let targetWidth = parseInt(component.data('width')) || 1200;
                let targetHeight = parseInt(component.data('height')) || 630;

                jQuery.ajax({
                    url: component.data('crop-url'),
                    method: 'POST',
                    data: {
                        original: item.data('original'),
                        cropped: item.data('cropped'),
                        name: item.data('name'),
                        field: component.data('field'),
                        x: data.x,
                        y: data.y,
                        width: data.width,
                        height: data.height,
                        targetWidth: targetWidth,
                        targetHeight: targetHeight,
                        multiple: component.data('multiple') ? 1 : 0,
                    },
                    success: function (data) {
                        config.modal.modal('hide');
                        if (data.success) {
                            item.replaceWith(data.html);
                            if (window.showToast) window.showToast('Изображение обрезано', 'success');
                        }
                    },
                    error: function (xhr) {
                        let msg = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : 'Ошибка при обработке';
                        if (window.showToast) window.showToast(msg, 'danger');
                    },
                    complete: hideLoadBox
                });
            }
        });
    });
});
